import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './MonthYearPicker.scss';

interface MonthYearPickerProps {
  name: string;
  id: string;
  value: string | null;
  min: string;
  placeholder: string;
}

function parseISODate(isoDate: string): Date {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(year, month - 1, day || 1);
}

function formatMonthYear(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${month}/${date.getFullYear()}`;
}

export default function MonthYearPicker({
  name,
  id,
  value,
  min,
  placeholder,
}: MonthYearPickerProps) {
  const [selected, setSelected] = useState<Date | null>(
    value ? parseISODate(value) : null,
  );

  return (
    <>
      <input
        type="hidden"
        name={name}
        value={selected ? formatMonthYear(selected) : ''}
      />
      <DatePicker
        id={id}
        selected={selected}
        onChange={(date: Date | null) => setSelected(date)}
        showMonthYearPicker
        showFourColumnMonthYearPicker
        popperPlacement="bottom-start"
        dateFormat="MM/yyyy"
        minDate={parseISODate(min)}
        placeholderText={placeholder}
        className="form-control form__input"
        autoComplete="off"
      />
    </>
  );
}
